import React, { useRef } from "react";
import { Container, Row, Col } from "react-bootstrap";
import SectionTitle from "../../common/SectionTitle/SectionTitle";
import "./TechnologySection.css";


export default function TechnologySection({ vehicle }) {
    const techSlides = vehicle.technologySlides || [];
    const sliderRef = useRef(null);

    if (!techSlides.length) return null;

    const scrollByAmount = (direction) => {
        if (!sliderRef.current) return;
        const slider = sliderRef.current;
        const width = slider.getBoundingClientRect().width;

        slider.scrollBy({
            left: direction === "right" ? width : -width,
            behavior: "smooth"
        });
    };

    return (
        <section className="technology-section section-spacing">
            <Container fluid>
                <div className="text-center">
                    <SectionTitle
                        subtitle="Technology &"
                        title="Innovation"
                    />

                    <p className="brand-section-desc">While others rely on guesswork, LANDKING relies on data and dominance.</p>
                </div>


                <div className="technology-section__slider-wrapper">
                    <div className="technology-section__slider" ref={sliderRef}>
                        {techSlides.map((slide) => (
                            <div
                                key={slide.id}
                                className="technology-section__slide"
                            >
                                <Row className="align-items-center g-4">
                                    {/* Left column: text */}
                                    <Col xs={12} lg={6}>
                                        <div className="technology-section__text">
                                            <h3 className="technology-section__slide-title">
                                                {slide.title}
                                            </h3>
                                            {slide.paragraph1 && (
                                                <p className="technology-section__paragraph">
                                                    {slide.paragraph1}
                                                </p>
                                            )}
                                            {slide.paragraph2 && (
                                                <p className="technology-section__paragraph">
                                                    {slide.paragraph2}
                                                </p>
                                            )}
                                        </div>
                                    </Col>

                                    {/* Right column: image */}
                                    <Col xs={12} lg={6}>
                                        <div className="technology-section__image-wrapper">
                                            {slide.imageSrc && (
                                                <img
                                                    src={slide.imageSrc}
                                                    alt={slide.title}
                                                    className="technology-section__image"
                                                />
                                            )}
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                        ))}
                    </div>
                </div>

                <div className="text-center">
                    <div className="technology-section__controls">
                        <button
                            type="button"
                            className="technology-section__arrow"
                            onClick={() => scrollByAmount("left")}
                            aria-label="Previous technology slide"
                        >
                            ‹
                        </button>
                        <button
                            type="button"
                            className="technology-section__arrow"
                            onClick={() => scrollByAmount("right")}
                            aria-label="Next technology slide"
                        >
                            ›
                        </button>
                    </div>
                </div>
            </Container>
        </section>
    );
}
